import { render, staticRenderFns } from "./PicklPurchases.vue?vue&type=template&id=247c6e2f&scoped=true&"
import script from "./PicklPurchases.vue?vue&type=script&lang=js&"
export * from "./PicklPurchases.vue?vue&type=script&lang=js&"
import style0 from "./PicklPurchases.vue?vue&type=style&index=0&id=247c6e2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c6e2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('247c6e2f')) {
      api.createRecord('247c6e2f', component.options)
    } else {
      api.reload('247c6e2f', component.options)
    }
    module.hot.accept("./PicklPurchases.vue?vue&type=template&id=247c6e2f&scoped=true&", function () {
      api.rerender('247c6e2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/PicklPurchases.vue"
export default component.exports